import { connectModal, Modal, useModal } from '@gsa/afp-component-library';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

const AttachmentModal = ({
  id,
  title,
  className,
  show,
  actions,
  onClose,
  hideClose,
  variant,
  children,
}) => {
  const { isOpen, openModal, closeModal } = useModal();

  const classes = classnames('attachment-modal', className);

  useEffect(() => {
    if (show) {
      openModal();
    } else {
      closeModal();
    }
  }, [show]);

  const AddModal = useMemo(
    () => () => (
      <Modal
        id={id}
        className={classes}
        title={title}
        hideClose={hideClose}
        onClose={() => {
          closeModal();
          onClose();
        }}
        actions={actions}
        variant={variant}
      >
        {children}
      </Modal>
    ),
    [show, actions],
  );

  const ConnectedModal = connectModal(AddModal);

  return <ConnectedModal isOpen={isOpen} onClose={closeModal} />;
};

AttachmentModal.defaultProps = {
  id: 'attachment-modal',
  className: 'modal',
  title: null,
  children: null,
  actions: null,
  show: false,
  onClose: () => {},
  hideClose: false,
};
AttachmentModal.propTypes = {
  id: PropTypes.string,
  title: PropTypes.node,
  show: PropTypes.bool,
  actions: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func,
  hideClose: PropTypes.bool,
  variant: PropTypes.oneOf(['extra-large', 'large']),
};

export default AttachmentModal;
